import type { MouseEvent } from 'react';

import { formatNumericDateTime } from '@/shared/lib/time-utils';

import { MarkDoneItem } from './mark-done-popover/mark-done-item';

interface Props {
    markedDoneAt: Date | null;
    onUndo: () => void;
    onMoreConfetti: (e: MouseEvent<HTMLButtonElement>) => void;
}

export function MarkDonePopover({ markedDoneAt, onUndo, onMoreConfetti }: Props) {
    const markedDoneDescription = markedDoneAt
        ? `Marked as done ${formatNumericDateTime(markedDoneAt)}`
        : 'Undo the mark done action';

    return (
        <div className="flex flex-col">
            <MarkDoneItem
                text="Undo Mark Done"
                description={markedDoneDescription}
                onClick={(e) => {
                    e.stopPropagation();
                    onUndo();
                }}
            />

            <div className="flex flex-col gap-2">
                <MarkDoneItem
                    text="🎉 More Confetti"
                    description="You deserve to celebrate"
                    onClick={(e) => {
                        e.stopPropagation();
                        onMoreConfetti(e);
                    }}
                />
            </div>
        </div>
    );
}
